
import { Vue, Component, Prop } from "vue-property-decorator";
import Axios from "axios";

@Component({
  name: "SumoSimulationInfo",
})
export default class SumoSimulationInfo extends Vue {
  @Prop({ type: Number, default: 0 }) readonly vehicleCount!: Number;

  private simulationStarted = false;
  private statusUrl = "";
  private guid = "";
  private queryTimer!: number;

  public startSimulation(statusUrl: string, guid: string) {
    this.simulationStarted = true;
    this.statusUrl = statusUrl;
    this.guid = guid;
    this.getSimulationStatus();
    this.queryTimer = setInterval(() => {
      this.getSimulationStatus();
    }, 1000);
  }

  public stopSimulation() {
    this.simulationStarted = false;
    clearInterval(this.queryTimer);
  }

  private async getSimulationStatus() {
    const response = await Axios.get(this.statusUrl, {
      params: { guid: this.guid },
    });
    console.log(response.data);
  }
}
